import React from 'react';
import type { Dispatch } from 'redux';
import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import VersionPicker from '@atlassian/jira-version-picker/src/view/single/index.tsx';
import type { VersionId } from '../../../../common/model/index.tsx';
import { setOperationForField, setVersionForField } from '../../../state/actions.tsx';
import {
	getProjectKey,
	getFieldOperation,
	getFieldTargetVersion,
	getVersionId,
	isInProgress,
	isFieldVersionPickerDisabled,
} from '../../../state/selectors.tsx';
import type { State } from '../../../state/types.tsx';
import MoveVersion, { type VersionPickerProps } from './MoveVersion.tsx';

type Props = {
	id: VersionId;
};

const VERSION_STATUS_WHITELIST = ['released', 'unreleased'];

const mapStateToProps = (state: State, ownProps: Props) => ({
	renderVersionPicker: ({ onChange }: VersionPickerProps): React.JSX.Element => (
		<VersionPicker
			onSelected={onChange}
			projectKey={getProjectKey(state)}
			ignore={[getVersionId(state)]}
			versionStatuses={VERSION_STATUS_WHITELIST}
			isDisabled={isFieldVersionPickerDisabled(state, ownProps.id)}
		/>
	),
	operation: getFieldOperation(state, ownProps.id),
	target: getFieldTargetVersion(state, ownProps.id),
	isDisabled: isInProgress(state),
});

const mapDispatchToProps = (
	dispatch: Dispatch<{
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		type: any;
	}>,
	ownProps: Props,
) => ({
	// @ts-expect-error - TS7006 - Parameter 'operation' implicitly has an 'any' type.
	onOperationChanged: (operation) =>
		dispatch(setOperationForField({ operation, fieldId: ownProps.id })),
	// @ts-expect-error - TS7006 - Parameter 'versionId' implicitly has an 'any' type.
	onTargetVersionChanged: (versionId) =>
		dispatch(setVersionForField({ target: versionId, fieldId: ownProps.id })),
});

// @ts-expect-error - TS2345 - Argument of type 'ComponentType<Diff<Record<any, any> | (Record<any, any> & { children?: ReactNode; }), InjectIntlVoidProps>>' is not assignable to parameter of type 'Component<{ renderVersionPicker: ({ onChange }: VersionPickerProps) => Element; operation: Operation | undefined; target: string | undefined; isDisabled: boolean; } & { ...; } & Props>'.
export default connect(mapStateToProps, mapDispatchToProps)(MoveVersion);
